export enum RfiTemplateTypes {
  Client = 'C',
  Vessel = 'V',
}
